import {MutationTree} from 'vuex';
import {RootState} from '@/store';

export const mutations: MutationTree<RootState> = {}
